import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useAuth } from '../../features/auth/AuthContext';
import { useEffect } from 'react';
import api from '../../api/api';
import { proceedToPayData, resetProceedToPay } from '../../state/actions/coursePaymentAction';
import './StripePayment.css'; // Make sure to create a CSS file for styles

import { useNavigate } from "react-router";
import { toast } from 'react-toastify';





const PracticeAssignmentRazorpayCheckout = ({ onClose ,setloading ,assignmentCheckoutData,onPaymentSuccess }) => {
    const { token } = useAuth();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [error, setError] = useState(false);
    const [paymentStatus, setPaymentStatus] = useState('');
    const [paymentSuccessPopup, setpaymentSuccessPopup] = useState(false);
    const [isPaymentLoading, setisPaymentLoading] = useState(false);
    const proceedToPay = useSelector((state) => state.proceedToPay);
    const [paymentData, setPaymentData] = useState(null)


    const {
    assignment,
    isAssignment,
    displayAssignmentType,
    lessonName,
    courseName,
    courseId,
    lessonId,
    price,
    courseType,
} = assignmentCheckoutData || {};



    const proceedToPaybtn = () => {
            if (!assignmentCheckoutData?.assignment) return; // nothing to pay for
            else{
    dispatch(proceedToPayData(token ,assignment,isAssignment,price));

            }
    };






    const handleSubmit = async () => {
        //event.preventDefault();        
        setloading(true)
        try {
            const payload = {
                order_id: proceedToPay?.order_id,
                purchase_type: "practice_assignment",
                payment_gateway: "razorpay",
            };
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            };
            const paymentIntentResponse = await api.post('payments/payment/', payload, config);
            setPaymentData(paymentIntentResponse.data);
            const clientSecret = paymentIntentResponse.data.client_secret

        } catch (err) {
            console.error(err);
        }
    };

    const LoadScript =()=>{
         return new Promise((resolve) => {
        // Don't load if already loaded
        if (window.Razorpay) {
            resolve(true);
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
    }

    const loadrazorpayScript = async () => {

    const scriptLoaded = await LoadScript();

    if (!scriptLoaded) {
        toast.error("Failed to load payment gateway. Please try again.");
        setloading(false);
        return;
    }

        if (paymentData != null) {
            let options = {
                key: paymentData?.key_id || "",
                amount: paymentData?.amount || 0,
                currency: paymentData?.currency || "INR",
                name: paymentData.name || "Proschool",
                notes: {
                    order_id: paymentData?.notes?.order_id,
                    purchase_type: paymentData?.notes?.purchase_type || "practice_assignment",
                },
                order_id: paymentData?.order_id || "",

                handler: function (response) {
                    //console.log(" SUCCESS:", response);
                    verifyPayment(response);
                },
                modal: {
                    ondismiss: function () {
                        dispatch(resetProceedToPay());
                        if (onClose) onClose(); // unmount this modal
                        setloading(false)

                    }
                },
                payment_gateway: paymentData?.payment_gateway || "razorpay",
                prefill: {
                    email: paymentData?.prefill?.email || "",
                    name: paymentData?.prefill?.name || "",
                }
            }
            //console.warn("open",paymentData, options);
            const rzp = new window.Razorpay(options);
            rzp.open();
            rzp.on("payment.failed", function (response) {
                setError(true)
                setisPaymentLoading(false)
                //bb
                    dispatch(resetProceedToPay());
    if (onClose) onClose();  // now also resets hidePopups per the fix above
                console.log("Payment Failed:", response);
            });
        }
        else{
            console.error("Payment data is not available.");
            setloading(false)
        }


    }

    const verifyPayment = async (response) => {
        try {
            const payload = {
                razorpay_order_id: response?.razorpay_order_id,
                razorpay_payment_id: response?.razorpay_payment_id,
                razorpay_signature: response?.razorpay_signature,
                order_id: proceedToPay?.order_id,
            };
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${token}`
                }
            };
            const verifyResponse = await api.post('/payments/verify-razorpay/', payload, config);
            console.log("Payment verification response:", verifyResponse.data);
            if (verifyResponse.data.status === 200) {
              //  console.warn("Razorpay success");
                
                setPaymentStatus('Payment succeeded!');
                setisPaymentLoading(false);
                setpaymentSuccessPopup(true);
                 // Payment verified server-side → generate. Popup owns navigation.
    if (onPaymentSuccess) {
        await onPaymentSuccess();
    }
                setloading(false)
                
            } else {
                setError(true);
                setloading(false)
            }
        } catch (err) {
            console.error("Payment verification failed:", err);
            setError(true);
            setloading(false)
        }
    }



    useEffect(() => {
        if (proceedToPay.order_id != null) {
            handleSubmit();
        }
    }, [proceedToPay.order_id])


    useEffect(() => {
        if (paymentData != null) {
            loadrazorpayScript();
        }

    }, [paymentData])

useEffect(() => {
        if (!assignmentCheckoutData?.assignment) return; // nothing to pay for
dispatch(proceedToPayData(token, assignment, isAssignment, price));    
    return () => {
        dispatch(resetProceedToPay()); // Clean up on unmount
    };
}, []);
 
// useEffect(() => {
// if(paymentSuccessPopup)    {
//       setTimeout(() => {
//         setpaymentSuccessPopup(false)
//         dispatch(cartList(token));
//         dispatch(resetRemoveCart());
//         navigate(`/dashboard/my-courses/active-courses`);
//       }, 5000)
// }
// },[paymentSuccessPopup])



    return (
        <>
            {/* <div>rpCheckout</div>
            <button onClick={proceedToPaybtn} >Pay</button> */}

            {/* PENDING POPUP */}
            {
                isPaymentLoading && <div>
                    <div className="pp-overlay">
                        <div className="pp-container">


                            {/* Icon */}
                            <div className="pp-icon" aria-hidden="true">
                                <div className="pp-doc">
                                    <span className="pp-line l1" />
                                    <span className="pp-line l2" />
                                    <span className="pp-line l3" />

                                    <span className="pp-check c1" />
                                    <span className="pp-check c2" />
                                </div>

                                <div className="pp-card">
                                    <span className="pp-card-strip" />
                                    <span className="pp-card-chip" />
                                </div>
                            </div>

                            <h2 className="pp-title">Please Wait</h2>

                            <p className="pp-sub">
                                Completing your transaction<span className="pp-dots" />
                            </p>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default PracticeAssignmentRazorpayCheckout


